import React, { useState, useEffect } from 'react';
import { useGlobalState } from '../GlobalStateContext';
import '../css/RPCSelector.css';

// RPC节点列表
const RPC_ENDPOINTS = [
  'https://bsc-dataseed.nariox.org',
  'https://bsc-dataseed.defibit.io',
  'https://bsc-dataseed.ninicoin.io',
  'https://bsc.nodereal.io',
  'https://bsc-dataseed-public.bnbchain.org',
  'https://bsc-rpc.publicnode.com',
  'https://rpc-bsc.48.club'
];

const RPCSelector = () => {
  const { rpcNode, updateRpcNode } = useGlobalState();
  const [customRpc, setCustomRpc] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');

  // 检查当前选择是否为自定义RPC
  useEffect(() => {
    const isCustom = rpcNode !== 'auto' && !RPC_ENDPOINTS.includes(rpcNode);
    setShowCustomInput(isCustom);
    if (isCustom) {
      setCustomRpc(rpcNode);
    }
  }, [rpcNode]);

  // 验证RPC节点连接
  const validateRpcEndpoint = async (url) => {
    try {
      setIsValidating(true);
      setValidationMessage('检测连接中...');
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          jsonrpc: '2.0',
          method: 'eth_chainId',
          params: [],
          id: 1,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.result === '0x38') { // BSC Chain ID
          setValidationMessage('✓ 连接成功');
          return true;
        } else {
          setValidationMessage('✗ 不是BSC网络');
          return false;
        }
      } else {
        setValidationMessage('✗ 连接失败');
        return false;
      }
    } catch (error) {
      setValidationMessage('✗ 连接错误');
      return false;
    } finally {
      setIsValidating(false);
      // 清除验证消息
      setTimeout(() => setValidationMessage(''), 3000);
    }
  };

  const handleRpcChange = (event) => {
    const value = event.target.value;
    
    if (value === 'custom') {
      setShowCustomInput(true);
      // 如果之前有自定义RPC，保持它，否则清空
      if (customRpc) {
        updateRpcNode(customRpc);
      }
    } else {
      setShowCustomInput(false);
      updateRpcNode(value);
      setValidationMessage('');
    }
  };

  const handleCustomRpcChange = (event) => {
    const value = event.target.value;
    setCustomRpc(value);
    if (value.trim()) {
      updateRpcNode(value.trim());
    }
  };

  const handleCustomRpcBlur = async () => {
    if (!customRpc.trim()) {
      // 如果自定义RPC为空，回退到auto
      updateRpcNode('auto');
      setShowCustomInput(false);
      setValidationMessage('');
    } else {
      // 验证自定义RPC
      await validateRpcEndpoint(customRpc.trim());
    }
  };

  const getCurrentSelectValue = () => {
    if (rpcNode === 'auto') return 'auto';
    if (RPC_ENDPOINTS.includes(rpcNode)) return rpcNode;
    return 'custom';
  };

  const getDisplayName = (endpoint) => {
    const cleanUrl = endpoint.replace('https://', '');
    if (cleanUrl.length > 35) {
      return cleanUrl.substring(0, 32) + '...';
    }
    return cleanUrl;
  };

  return (
    <div className="rpc-selector-container">
      <div className="rpc-select-group">
        <label htmlFor="rpc-select">选择RPC节点:</label>
        <select
          id="rpc-select"
          value={getCurrentSelectValue()}
          onChange={handleRpcChange}
          className="neu-select"
        >
          <option value="auto">🚀 自动选择 (最快节点)</option>
          <optgroup label="📡 预设节点">
            {RPC_ENDPOINTS.map((endpoint, index) => (
              <option key={index} value={endpoint}>
                {getDisplayName(endpoint)}
              </option>
            ))}
          </optgroup>
          <option value="custom">⚙️ 自定义节点</option>
        </select>
      </div>
    </div>
  );
};

export default RPCSelector; 